import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  searchField: {
    '&&': {
      // flexGrow: 1,
      height: 'inherit',
    },
  },
  searchFieldInput: {
    '&&': {
      width: 'inherit',
      height: 'inherit',

      border: `1px solid ${theme.palette.custom.grey}`,

      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,

      '&::placeholder': {
        fontWeight: FONTS.WEIGHTS.bold,
        fontSize: FONTS.SIZES.s,
        lineHeight: 1.33,

        color: theme.palette.custom.grey2,
      },

      [theme.breakpoints.down('laptop_l')]: {
        borderRadius: '17.5px',
      },
      [theme.breakpoints.up('laptop_l')]: {
        borderRadius: '30px',
      },
    },
  },
}))

export default useStyles
